import MarkdownIt from 'markdown-it';
import { sanitizeHtml } from '../utils/sanitize';

const md = new MarkdownIt({
  html: false,       // don't allow raw HTML in descriptions — safer
  breaks: true,      // single-line breaks render as <br>
  linkify: true,     // auto-link URLs
});

/**
 * Renders a camp / program / tournament description that may be stored as
 * either markdown (legacy) or HTML (rich text editor output).
 *
 * Detection is cheap: if the string contains a tag-like `<p>`, `<br>`, etc.
 * we trust it's HTML; otherwise we markdown-render.
 */
const looksLikeHtml = (s) => typeof s === 'string' && /<\/?[a-z][\s\S]*?>/i.test(s);

export const DescriptionView = ({ value, className = '' }) => {
  if (!value) return null;
  const html = looksLikeHtml(value) ? value : md.render(value);
  return (
    <div
      className={`prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  );
};

export default DescriptionView;
